export enum Colors {
  WHITE = 'White',
  BLACK = 'Black'
}
